import $ from 'jquery';
import { mapState } from 'vuex';

import * as endpoints from '@/common/endpoints';

export const cardsMixins = {
  data() {
    return {
      itemOpen: null,
      maxHeight: 0,
    };
  },
  methods: {
    setOpen(id) {
      this.itemOpen = id;
    },
    /**
     * This function filters the items based on
     * any given category name
     * @param {Object} item - Item to be filtered
     * @param {String} category - Filter name inside Directus
     * @param {Boolean} multipleFilters - If there are more than one
     * filter in the current page, instance.
     * @param {String} itemName - Just in case the Single filter's name
     * is different from the category name
     * @returns
     */
    doFilter(item, category, multipleFilters = true, itemName = null) {
      const arrayOfSelectedFilters = (multipleFilters)
        ? this.selectedFilters[category]
        : this.selectedFilters;

      const currentItemTags = item[`filters_${category}`].map((tag) => tag[`${itemName || category}_id`].id);

      if (arrayOfSelectedFilters.length > 0) {
        return currentItemTags.some((tag) => arrayOfSelectedFilters.includes(tag));
      }

      return true;
    },
    /**
     * This Function retrieves all the filters
     * in one card and make the translations
     * @param {Object} card - parent item
     * @param {String} category - filter name inside Directus Database
     * @param {String} itemName - Just in case the Single filter's name
     * is different from the category name
     * @returns Array with the translation of the filter's name
     */
    getTranslatedFilter(card, category, itemName = null) {
      return card[`filters_${category}`]
        .map((filterItem) => filterItem[`${itemName || category}_id`].translations
          .filter(
            (i) => i.languages_code === this.$i18n.locale,
          )[0]);
    },
    matchHeight(dataName) {
      const items = document.querySelectorAll(dataName);
      const allHeights = [];

      for (let i = 0; i < items.length; i += 1) {
        items[i].style.height = 'auto';
        allHeights.push(items[i].offsetHeight);
      }
      if (Number.isNaN(this.maxHeight)) {
        return false;
      }
      this.maxHeight = Math.max.apply(null, allHeights);

      for (let i = 0; i < items.length; i += 1) {
        items[i].style.height = `${this.maxHeight}px`;
      }

      return true;
    },

  },
  computed: {
    // Receives the Key of the filter
    filterList() {
      return (category) => {
        const filterItems = this.items.map((item) => item[category]);
        return [...new Set(filterItems.flat())];
      };
    },
  },
};

export const defaultMixins = {
  data() {
    return {
      cmsURL: endpoints.CMS,
      isReady: false,
    };
  },
  methods: {
    hideMainTabs() {
      $('.js-header-tabs').fadeOut('fast');
    },
    showMainTabs() {
      $('.js-header-tabs').fadeIn('fast');
    },
    clickTracked() {
      console.log('not tracking');
    },
    // Share List Tracking
    shareTracking() {
      console.log('not share tracking');
    },
    shareThis(payload) {
      console.log(payload);

      if (payload.checked) {
        return this.$store.commit('addToShare', payload.data);
      }
      return this.$store.commit('removeItem', payload.data);
    },
    updateShared(sharedArr) {
      $('.js-share-button').prop('checked', false);

      sharedArr.map((item) => $(`.js-share-button[data-hash="${item.hash}"]`).prop('checked', true));
    },
  },
  watch: {
    sharedList(latestState) {
      if (this.updateShared) {
        this.updateShared(latestState);
      }
    },
  },
  mounted() {
    this.updateShared(this.sharedList);
  },
  updated() {
    if (this.updateShared) {
      this.updateShared(this.sharedList);
    }
  },
  computed: {
    // Maps State to data
    ...mapState([
      'companyContact',
      'currentPrinter',
      'salesPerson',
      'sharedList',
    ]),
    // Print printer name based on ID
    printerName() {
      const printerObj = {
        1: 'T250 HD',
        2: 'T400 Series',
        3: 'Advantage 2200',
      };
      return printerObj[this.currentPrinter];
    },
    // Get current Printer's data
    getDataByPrinter() {
      if (this.info) {
        if (Array.isArray(this.info)) {
          const [currentPrinterData] = this.info
            .filter((item) => item.printer
              .some((printer) => printer.printers_id === this.currentPrinter));

          return currentPrinterData;
        }

        return this.info;
      }

      return false;
    },
    // Get Translated data
    getData() {
      if (this.info) {
        // Set fallback to english data
        const [defaultEnglishData] = this.getDataByPrinter.translations
          .filter((item) => item.languages_code === this.$i18n.fallbackLocale);

        // Get current language data
        const [translatedData] = this.getDataByPrinter.translations
          .filter((item) => item.languages_code === this.$i18n.locale);

        return translatedData || defaultEnglishData;
      }

      return false;
    },
  },
};

export const filters = {
  methods: {
    slugify(string) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
      const p = new RegExp(a.split('').join('|'), 'g');

      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    },
    trim(string) {
      return string.replace(/ /g, '');
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    uppercase(string) {
      return string.toUpperCase();
    },
    hashify(string) {
      return window.btoa(unescape(encodeURIComponent(string)));
    },
  },
};

export const loginMixins = {
  methods: {
    parsleyTheForm(target) {
      const $validationOptions = {
        trigger: 'focusout',
        excluded: ':hidden',
        errorsWrapper: '<span></span>',
        errorTemplate: '<span class="msg-is-invalid"></span>',
      };

      return $(target).parsley($validationOptions)
        .on('field:error', (data) => {
          console.error(`-- Validation Error -- for ${target}`, data.$element[0].name, data.$element[0].class);
        });
    },
  },
};
